// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PencilSlashIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6.74 4.327a1 1 0 1 0-1.48 1.346l6.025 6.624L4.585 19A1.986 1.986 0 0 0 4 20.414V26a2 2 0 0 0 2 2h5.586A1.984 1.984 0 0 0 13 27.414l6.3-6.299 5.961 6.558a1 1 0 1 0 1.48-1.345l-20.001-22Zm7.875 11.64L8.5 22.088 6.414 20l6.219-6.217 1.982 2.184ZM6 22.415 9.586 26H6v-3.586Zm6 3.172L9.915 23.5l6.051-6.051 1.987 2.185L12 25.586ZM28.415 9.171l-5.586-5.585a2.002 2.002 0 0 0-2.829 0l-5.209 5.209a.999.999 0 1 0 1.415 1.414L17 9.414l2.086 2.086-.961.961a1 1 0 1 0 1.414 1.414l.961-.961L22.586 15l-1.125 1.125a1.001 1.001 0 1 0 1.414 1.418L28.415 12a2 2 0 0 0 0-2.829ZM24 13.586 18.415 8l3-3L27 10.586l-3 3Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
